export default "__VITE_ASSET__CTFWKp8L__"